import { useState } from 'react';
import { SectionCard } from './section-card';
import { useAuth } from '@/hooks/use-auth';
import { deleteAccount } from '@/lib/settings-api';

const CONFIRM_PHRASE = 'LÖSCHEN';

export function DangerSection() {
  const { accessToken, signOut } = useAuth();
  const [phrase, setPhrase] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleDelete() {
    if (!accessToken) return;
    setBusy(true);
    setError('');
    try {
      await deleteAccount(accessToken);
      signOut();
      window.location.href = '/';
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Löschen fehlgeschlagen');
      setBusy(false);
    }
  }

  return (
    <SectionCard title="Konto löschen" description="Das kann nicht rückgängig gemacht werden." danger>
      <label className="block text-sm text-slate-300">
        Tippe <span className="font-mono text-red-300">{CONFIRM_PHRASE}</span> zur Bestätigung
        <input
          value={phrase}
          onChange={(e) => setPhrase(e.target.value)}
          className="mt-1 w-full rounded-lg border border-red-500/40 bg-slate-950/60 px-3 py-2 text-slate-100"
        />
      </label>
      {error ? <p className="text-sm text-red-400">{error}</p> : null}
      <button
        type="button"
        onClick={handleDelete}
        disabled={phrase !== CONFIRM_PHRASE || busy}
        className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-500 disabled:opacity-40"
      >
        Konto endgültig löschen
      </button>
    </SectionCard>
  );
}
